/** @format */

import LazyLoad from "./library/LazyLoad";
import Messages from "./library/Messages";
import Forms from "./components/Forms";
import FormsValidation from "./components/FormsValidation";
import Popups from "./components/Popups";
import Webshop from "./components/Webshop";
import Header from "./components/Header";
import Carousels from "./components/Carousels";
import Navigation from "./components/Navigation";
import Tabs from "./components/Tabs";
import Accordion from "./components/Accordion";
import Zoom from "./components/Zoom";
import Copy from "./components/Copy";
import Tooltips from "./components/Tooltips";
//import Chat from './components/Chat';
import ScrollToEl from "./components/ScrollToEl";
import Attributes from "./components/Shop/Attributes";
import Product from "./components/Shop/Product";
import Filters from "./components/Shop/Filters";
import Search from "./components/Shop/Search";
import Basket from "./components/Shop/Basket";
import Wishlist from "./components/Shop/Wishlist";
import Checkout from "./components/Shop/Checkout";
import Quotes from "./components/Shop/Quotes";
import Returns from "./components/Shop/Returns";
import Personalise from "./components/Shop/Personalise";
import Kitbuilder from "./components/KitBuilder.js";
import KitKreator from "./components/KitKreator.js";
import ScrollSpy from "./components/ScrollSpy";
import Toggle from "./components/Toggle";
import Engravings from "./components/Shop/Engravings";
import Sponsors from "./components/Shop/Sponsors";
import CustomBadge from "./components/Shop/CustomBadge";
import Locale from "./components/Locale";
import $ from "jquery";
global.jQuery = global.$ = $;
// Required for IE
require("./library/AssignPolyfill.js");
require("./library/ReplaceAllPolyfill.js");
require("./plugins/Modernizr.js");
// Legacy framework removed - using native OctoberCMS v3 AJAX framework
$(() => {
	// Plugins
	require("./plugins/jquery.serializejson.js");
	// require("./plugins/ImagesLoaded.js");
	require("./library/StubConsole.js");
	require("./library/Request.js");
	require("./library/ReCaptcha.js");
	require("./../../node_modules/select2/dist/js/select2.js");
	require("./../../node_modules/pickadate/lib/picker.js");
	require("./../../node_modules/pickadate/lib/picker.date.js");
	require("./../../node_modules/magnific-popup/dist/jquery.magnific-popup.js");
	require("./../../node_modules/slick-carousel/slick/slick.js");
	require("./../../node_modules/jquery-zoom/jquery.zoom.js");
	LazyLoad.init();
	Messages.init();
	Forms.init();
	FormsValidation.init();
	Popups.init();
	Webshop.init();
	Header.init();
	Carousels.init();
	Navigation.init();
	Tabs.init();
	Copy.init();
	Tooltips.init();
	//Chat.init();
	ScrollToEl.init();
	Accordion.init();
	Search.init();
	Attributes.init();
	Product.init();
	Filters.init();
	Basket.init();
	Wishlist.init();
	Checkout.init();
	Quotes.init();
	Returns.init();
	Personalise.init();
	Kitbuilder.init();
	KitKreator.init();
	ScrollSpy.init();
	Toggle.init();
	Engravings.init();
	Sponsors.init();
	CustomBadge.init();
	Locale.init();
});
